module.exports = true;


// WEBPACK FOOTER //
// ./~/core-js/library/modules/_library.js